import apiFetch from '@wordpress/api-fetch';

async function getCoveoToken( filter = '' ) {
	try {
		const tokenResponse = await apiFetch( {
			path: `coveo-search-interface/v1/token${ filter ? `/?filter=${ filter }` : '' }`,
			cache: 'no-store',
			headers: {
				'Cache-Control': 'no-store',
				Pragma: 'no-cache',
				Expires: '0',
			},
		} );

		if ( typeof tokenResponse.token !== 'string' || ! tokenResponse.token ) {
			throw new Error( `HTTP error! Status: ${ tokenResponse }` );
		}

		return tokenResponse.token;
	} catch ( error ) {
		console.error( 'Fetch error:', error );
		return null;
	}
}

export async function getCoveoFacets() {
	const url = `https://${ COVEO_ORG_ID }.org.coveo.com/rest/search/v3/fields?organizationId=${ COVEO_ORG_ID }&pipeline=default&searchHub=${ COVEO_SEARCH_HUB }`;
	const token = await getCoveoToken();

	const reqHeaders = new Headers( {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		Authorization: `Bearer ${ token }`,
	} );

	try {
		const response = await fetch( url, {
			method: 'GET',
			headers: reqHeaders,
		} );

		if ( ! response.ok ) {
			throw new Error( `Response status: ${ response.status }` );
		}

		const data = await response.json();

		// groupByField - facet field
		// splitGroupByField - multi-value facet field
		return (
			data.fields
				?.filter(
					( field ) =>
						( field.groupByField === true || field.splitGroupByField === true ) &&
						[
							'LargeString',
							'Date',
						].includes( field.fieldType )
				)
				.sort( ( a, b ) => a.name.localeCompare( b.name ) ) || []
		);
	} catch ( error ) {
		console.error( error.message );
	}
}

export default getCoveoToken;
